<template>
  <layout-header></layout-header>
  <div class="page-wrapper">
    <div class="content">
      <div class="container">
        <div class="row">
          <!-- Booking -->
          <div class="col-lg-12">
            <!-- Booking Step -->
            <ul class="step-register row">
              <li class="activate col-md-4">
                <div class="multi-step-icon">
                  <span
                    ><img src="@/assets/img/icons/calendar-icon.svg" alt="img"
                  /></span>
                </div>
                <div class="multi-step-info">
                  <h6>Appointment</h6>
                  <p>Choose time & date for the service</p>
                </div>
              </li>
              <li class="active col-md-4">
                <div class="multi-step-icon">
                  <span><img src="@/assets/img/icons/wallet-icon.svg" alt="img" /></span>
                </div>
                <div class="multi-step-info">
                  <h6>Payment</h6>
                  <p>Select Payment Gateway</p>
                </div>
              </li>
              <li class="col-md-4">
                <div class="multi-step-icon">
                  <span><img src="@/assets/img/icons/book-done.svg" alt="img" /></span>
                </div>
                <div class="multi-step-info">
                  <h6>Done</h6>
                  <p>Completion of Booking</p>
                </div>
              </li>
            </ul>
            <!-- /Booking Step -->

            <!-- Booking Payment -->
            <div class="row">
              <div class="col-lg-6">
                <h5 class="pay-title">Payment Methods</h5>
                <div class="row g-3">
                  <div class="col-lg-6">
                    <div>
                      <input
                        type="radio"
                        class="btn-check"
                        name="btnradio"
                        id="btnradio1"
                        checked
                      />
                      <label
                        class="btn btn-check-label bg-light-500 w-100 d-flex justify-content-between align-items-center"
                        for="btnradio1"
                      >
                        <span class="d-flex align-items-center"
                          ><span class="check-outer me-2"><i></i></span>Wallet</span
                        >
                        <span><i class="ti ti-wallet"></i></span>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div>
                      <input
                        type="radio"
                        class="btn-check"
                        name="btnradio"
                        id="btnradio2"
                      />
                      <label
                        class="btn btn-check-label bg-light-500 w-100 d-flex justify-content-between align-items-center"
                        for="btnradio2"
                      >
                        <span class="d-flex align-items-center"
                          ><span class="check-outer me-2"><i></i></span>Paypal</span
                        >
                        <span><i class="ti ti-brand-paypal"></i></span>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div>
                      <input
                        type="radio"
                        class="btn-check"
                        name="btnradio"
                        id="btnradio3"
                      />
                      <label
                        class="btn btn-check-label bg-light-500 w-100 d-flex justify-content-between align-items-center"
                        for="btnradio3"
                      >
                        <span class="d-flex align-items-center"
                          ><span class="check-outer me-2"><i></i></span>Cash On
                          Delivery</span
                        >
                        <span><i class="ti ti-coin"></i></span>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="credit-card-option">
                      <input
                        type="radio"
                        class="btn-check"
                        name="btnradio"
                        id="btnradio4"
                      />
                      <label
                        class="btn btn-check-label bg-light-500 w-100 d-flex justify-content-between align-items-center"
                        for="btnradio4"
                      >
                        <span class="d-flex align-items-center"
                          ><span class="check-outer me-2"><i></i></span>Credit / Debit
                          Card</span
                        >
                        <span><i class="ti ti-coin"></i></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="payment-list" style="display: none">
                  <div class="row align-items-center">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="col-form-label">Name on Card</label>
                        <input
                          class="form-control"
                          type="text"
                          placeholder="Enter Name on Card"
                        />
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <label class="col-form-label">Card Number</label>
                        <input
                          class="form-control"
                          placeholder="**** **** **** ****"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-md-4 text-end">
                      <div class="form-group">
                        <label class="col-form-label">&nbsp;</label>
                        <!-- <img
                          src="@/assets/img/payment-card.png"
                          class="img-fluid"
                          alt="image"
                        /> -->
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">Expiration date</label>
                        <input class="form-control" placeholder="MM/YY" type="text" />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="col-form-label">Security code</label>
                        <input class="form-control" placeholder="CVV" type="text" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <h5 class="pay-title">Booking Summary</h5>
                <div class="summary-box">
                  <div class="booking-info">
                    <div class="service-book">
                      <div class="service-book-img">
                        <img src="@/assets/img/services/rated-service-07.jpg" alt="img" />
                      </div>
                      <div class="serv-profile">
                        <span class="badge badge-soft-primary">Car Wash</span>
                        <h2>Car Repair Services</h2>
                        <ul>
                          <li class="serv-pro">
                            <img src="@/assets/img/profiles/avatar-01.jpg" alt="img" />
                          </li>
                          <li class="serv-review">
                            <i class="fa-solid fa-star"></i> <span>4.9 </span>(255
                            reviews)
                          </li>
                          <li class="service-map">
                            <i class="feather-map-pin"></i> Alabama, USA
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="booking-summary">
                    <ul class="booking-date">
                      <li>Date <span>07/09/2023</span></li>
                      <li>Time <span>12.30 Pm - 01. 00 PM</span></li>
                      <li>Service Provider <span>Thomas Herzberg</span></li>
                    </ul>
                    <ul class="booking-date">
                      <li>Subtotal <span>$150.00</span></li>
                      <li>Coupoun Discount <span>$5.00</span></li>
                      <li>Services Charges <span>$3.00</span></li>
                    </ul>
                    <div class="booking-total">
                      <ul class="booking-total-list">
                        <li>
                          <span>Total</span>
                          <span class="total-cost">$148.00</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="booking-coupon">
                  <div class="form-group w-100">
                    <div class="coupon-icon">
                      <input type="text" class="form-control" placeholder="Coupon Code" />
                      <span
                        ><img src="@/assets/img/icons/coupon-icon.svg" alt="image"
                      /></span>
                    </div>
                  </div>
                  <div class="form-group">
                    <button class="btn btn-dark">Apply</button>
                  </div>
                </div>
                <div class="save-offer">
                  <p>
                    <i class="fa-solid fa-circle-check"></i> Your total saving on this
                    order $5.00
                  </p>
                </div>
                <div class="booking-pay">
                  <router-link to="/booking/booking-success" class="btn btn-dark me-3 w-100"
                    >Proceed to Pay $148</router-link
                  >
                  <a href="javascript:void(0);" class="btn btn-light">Skip</a>
                </div>
              </div>
            </div>
            <!-- /Booking Payment -->
          </div>
          <!-- /Booking -->
        </div>
      </div>
    </div>
  </div>
  <pages-footer></pages-footer>
</template>
